import React from "react";
import Tooltip from "@mui/material/Tooltip";

function OverflowTooltip({ text, maxLength, className }) {
  const isLong = text?.length > maxLength;
  const displayText = isLong ? `${text.slice(0, maxLength)}...` : text;

  if (!isLong) {
    return <p className={className}>{displayText}</p>;
  }

  return (
    <Tooltip title={text} arrow enterTouchDelay={0}>
      <p className={className}>{displayText}</p>
    </Tooltip>
  );
}

export default OverflowTooltip;
